export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-26-C-front-side-back-WEB-Large-0608b1c234160d572a31e84e7a7ce3c4.jpg";